import Vector from './Vector'

export default class Bounds {
  nw

  se

  reset() {
    this.nw = undefined
    this.se = undefined
  }

  addPoint(p) {
    this.nw = typeof this.nw === 'undefined' ? p : this.nw.min(p)
    this.se = typeof this.se === 'undefined' ? p : this.se.max(p)
  }

  addPoints(points) {
    points.forEach((p) => this.addPoint(p))
  }

  center() {
    return this.nw.midpoint(this.se)
  }

  size() {
    return this.se.sub(this.nw)
  }

  extend(diff) {
    const result = new Bounds()

    result.nw = this.nw.sub(diff)
    result.se = this.se.add(diff)

    return result
  }
}
